import React from 'react'
import createClass from 'create-react-class'
import Config, { TYPE } from './interface/Config'
import i18n from 'live/services/i18n'
import Instance from './interface/Instance'
import Select from 'react-select'

var FormBase = require('live/components/extensions/ui/form')
var FormGroup = require('live/components/forms/ui/form-group')

const ValidationMixin = require('live/components/forms/mixins/validation-mixin'),
    ObjectInitializerMixin = require('live/components/forms/mixins/object-initializer')('/rest/extension', {
        type: TYPE,
        active: true,
        config: {
            accessKey: '',
            secretKey: '',
            bucketName: '',
            folderName: '',            
            cron: '0 8 * * *',            
            filterExtensions: []
        },
        fullQualifier: null,
        qualifier: null,
        status: {}
    } as any)

export default createClass({
    mixins: [ObjectInitializerMixin, ValidationMixin],
    validations: {},
    _onSuccess: function () {
        window.location.href = '#/integrations/' + this.state.object.type + '/' + this.state.object.id
    },
    _onDelete: function () {
        window.location.href = '#/integrations/'
    },
    onChangeFilterExtensions: function (servers) {
        var object = this.state.object,
            config = object.config

        config.filterExtensions = servers
        this.applyObj({ config: config })
    },
    onChangeCheckbox: function (e) {
        var object = this.state.object,
            config = object.config,
            field = e.target.name

        config[field] = !config[field]
        this.applyObj({ config: config })
    },
    render: function () {
        const object = this.state.object
        const config = object.config || {}

        const {
            accessKey = '',
            secretKey = '',

            bucketName = '',
            folderName = '',
            cron = '0 8 * * *',            
            filterExtensions = []
        } = config as Instance

        return (
            <FormBase self={this}>
                <div className="form-area">
                    <FormGroup
                        type="password"
                        label={
                            <span>
                                {' '}
                                {i18n('Access key')}
                                <abbr title="required">*</abbr>
                            </span>
                        }
                        name="config.accessKey"
                        value={accessKey}
                        onChange={this.handleValidation}
                        validationState={this.validationState('config.accessKey')}
                        hasFeedback
                        help={this.errorsFor('config.accessKey')}
                    />

                    <FormGroup
                        type="password"
                        label={
                            <span>
                                {' '}
                                {i18n('Secret Key')}
                                <abbr title="required">*</abbr>
                            </span>
                        }
                        name="config.secretKey"
                        value={secretKey}
                        onChange={this.handleValidation}
                        validationState={this.validationState('config.secretKey')}
                        hasFeedback
                        help={this.errorsFor('config.secretKey')}
                    />

                    <FormGroup
                        type="text"
                        label={
                            <span>
                                {' '}
                                {i18n('Bucket Name')}
                                <abbr title="required">*</abbr>
                            </span>
                        }
                        name="config.bucketName"
                        value={bucketName}
                        onChange={this.handleValidation}
                        validationState={this.validationState('config.bucketName')}
                        hasFeedback
                        help={this.errorsFor('config.bucketName')}
                    />

                    <FormGroup
                        type="text"
                        label={
                            <span>
                                {' '}
                                {i18n('Folder Name')}
                                <abbr title="required">*</abbr>
                            </span>
                        }
                        name="config.folderName"
                        value={folderName}
                        onChange={this.handleValidation}
                        validationState={this.validationState('config.folderName')}
                        hasFeedback
                        help={this.errorsFor('config.folderName')}
                    />
                
                    <FormGroup
                        type="text"
                        label={
                            <span>
                                {' '}
                                {i18n('Cron')}
                                <abbr title="required">*</abbr>
                            </span>
                        }
                        name="config.cron"
                        value={cron}
                        onChange={this.handleValidation}
                        validationState={this.validationState('config.cron')}
                        hasFeedback
                        help={this.errorsFor('config.cron')}
                    />

                    <div className="form-group">
                        <div>
                            <label>Filter extensions</label>
                        </div>
                        <Select.Creatable
                            value={[...filterExtensions].map(value => ({ label: value, value }))}
                            options={[...filterExtensions].map(value => ({ label: value, value }))}
                            isMult={true}
                            multi={true}
                            onChange={(actions, options) => {
                                this.onChangeFilterExtensions(
                                    [...actions]
                                        .map(({ value }) => value)
                                        .filter(v => !!v)
                                        .map(v => String(v).toLowerCase())
                                )
                            }}
                        />
                    </div>
                </div>
            </FormBase>
        )
    }
})
